<template>
<div class="form-address">
  <gkFormCustomGroup
    class="address-wrap"
    :field="field"
    :rule="isValidity ? rules : []"
    :customRule="{ 'validAddress': customRule.validAddress }"
    :validity="isValidity"
     v-model="finalValue"
   >
    <template v-for="(option, i) in options">
      <div class="input-wrap" :class="{'detail-address': option.type === addressConstants.addressInput}" :key="i">
        <gkFormText
          :class="option.type === addressConstants.addressInput ? 'input' : 'select'"
          :field="'addressUseless'"
          :readonly="option.type !== addressConstants.addressInput"
          :placeholder="option.tips || defaultValue[option.type]"
          :value="addressValue[option.type]&& addressValue[option.type].name"
          :disabled="option.type !== addressConstants.addressInput && canFocusIndex < i"
          size="normal"
          color="gray"
          @focus="getSelectMessage($event,option.type)"
          @input="addressInput(option.type,$event)"
        />
      </div>
    </template>
  </gkFormCustomGroup>
  <div v-show="showAddressSelect && focusType !== addressConstants.addressInput">
    <ul ref="select-list" class="select-dropdown" :style="{left: inputStyle.left + 'px', top: inputStyle.top + 'px'}">
      <li
        v-for="item in selectMessage"
        :class="{isActive: activeId === item.id}"
        :key="item.id"
        @click="selectOption(focusType, item)"
      >
        {{item.name || '暂无数据'}}
      </li>
    </ul>
    <div class="cover" @click="showAddressSelect = false"></div>
  </div>
</div>
</template>

<script>
import VueTypes from 'vue-types'
import ConfigService from '@/service/config.service'
import gkFormCustomGroup from 'gkui/form/FormCustomGroup'
import gkFormText from 'gkui/form/FormText'
import * as addressConstants from '../const'

export default {
  name: 'common-address',
  components: {
    gkFormCustomGroup,
    gkFormText
  },
  data () {
    return {
      area_options: [],
      // 表单提交的值
      finalValue: [],
      // select 下拉数据源
      selectMessage: [],
      defaultValue: {
        [addressConstants.addressProvince]: '-省/自治区/直辖市-',
        [addressConstants.addressCity]: '-市-',
        [addressConstants.addressCountry]: '-区/县-',
        [addressConstants.addressInput]: '详细地址'
      },
      // 选中的数据
      addressValue: {},
      // 是否显示地址下拉 panel
      showAddressSelect: false,
      // 当前正在选择的下拉框
      focusType: '',
      inputStyle: {
        left: 0,
        top: 0
      },
      activeId: -1,
      addressConstants,
      canFocusIndex: 0
    }
  },
  computed: {
    field () {
      return `${this.data.id}-${this.data.type}`
    },
    isValidity () {
      return Boolean(this.data.showQuestion)
    },
    options () {
      return this.data.details.options || []
    },
    rules () {
     let rule = []
     if (this.data.is_must_answer) {
        rule.push({
          required: '必填'
        })
        rule.push({
          validAddress: '必填'
        })
     }
     return rule
    },
    customRule () {
      const options = this.options
      return {
        validAddress (value) {
          return {
            valid: value.length >= options.filter(item => item.type !== addressConstants.addressInput).length
          }
        }
      }
    }
  },
  props: {
    data: VueTypes.object.def({})
  },
  created () {
    ConfigService.getAreaList().then(data => {
      this.area_options = data
    })
  },
  methods: {
    /**
     * 选择省市区
     */
    getSelectMessage (event, type) {
      const { addressCity, addressCountry, addressProvince } = this.addressConstants
      // 浏览器新的标准采用composedPath 获取冒泡的所有元素
      let path = event.path || (event.composedPath && event.composedPath())
      this.inputStyle.left = path[2].offsetLeft
      this.inputStyle.top = path[2].offsetTop + 48

      this.focusType = type
      this.showAddressSelect = true

      if (type === addressProvince) {
        this.selectMessage = this.area_options
      } else if (type === addressCity && this.addressValue[addressProvince]?.id) {
        this.city_options = this.area_options.find(ele => ele.id === this.addressValue[addressProvince].id).city
        this.selectMessage = this.city_options.slice()
      } else if (type === addressCountry && this.addressValue[addressCity]?.id) {
        this.country_options = this.city_options.find(ele => ele.id === this.addressValue[addressCity].id).area
        this.selectMessage = this.country_options
      } else {
        this.selectMessage = ['暂无数据']
      }

      const activeId = this.addressValue[type]?.id
      if (activeId) {
        this.activeId = activeId
      }
    },
    // 添加详细地址
    addressInput (type, $event) {
      this.addressValue[type] = { name: $event }
      this.showAddressSelect = false
      this.setFinalValue()
    },
    // 汇总
    setFinalValue () {
      const finalValue = Object.entries(this.addressValue).map(([type, item]) => {
        const option = this.options.find(ele => ele.type === +type)
        const obj = { key: option.key, value: String(item.name) }
        return obj
      })
      this.finalValue = finalValue
    },
    // 设置input框的显示
    selectOption (type, item) {
      const { addressProvince, addressCity, addressCountry, addressInput } = addressConstants
      if (item.id !== this.activeId) {
        if (type === addressProvince) {
          delete this.addressValue[addressCity]
          delete this.addressValue[addressCountry]
          delete this.addressValue[addressInput]

          this.canFocusIndex = 1
        }
        if (type === addressCity) {
          delete this.addressValue[addressCountry]
          delete this.addressValue[addressInput]

          this.canFocusIndex = 2
        }
        if (type === addressCountry) {
          delete this.addressValue[addressInput]
        }
        this.addressValue[type] = item
        this.setFinalValue()
      }
      this.showAddressSelect = false
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../../../assets/css/_common";
$default-color: #828A92;

.form-address {
  position: relative;
  .cover{
    position: fixed; z-index: 10; top: 0; left: 0; right: 0; bottom: 0;
    background-color: transparent;
  }
  & .address-wrap {
    display: flex;
    flex-wrap: wrap; gap: 10px 9.5px;
    width: 80%;

    & .input-wrap {
      width: 175px;
      // margin-bottom: 10px;
      // margin-right: 9.5px;

      // &:nth-last-child(-n+2):not(:nth-child(-n+2)):not(:nth-child(3)) {
      //   margin-right: 0;
      // }

      & ::v-deep {
        & .gkui-form-element[data-color="gray"] {
          min-height: 40px;

          &[disabled] {
            background: #f3f3f3 !important;

            & .gkui-form-text {
              cursor: not-allowed;
            }
          }

          & .gkui-form-text {
            cursor: pointer;

              &::placeholder {
                font-size: 16px;
                color: rgba(130, 138, 146, 0.6);
                opacity: 1;
                zoom: 0.8;
              }
          }
        }

      }

      &.detail-address {
        margin-bottom: 0;
        width: 100%;

        & ::v-deep {
          & .gkui-form-element[data-color="gray"] {
            background: #fff;

            & .gkui-form-text {
              cursor: initial;

              &::placeholder {
                color: $default-color;
                opacity: .5;
              }
            }
          }
        }
      }

      & .select {
        cursor: pointer;
        &::after {
          content: '';
          position: absolute;
          right: 20px; top: 50%;
          width: 9px; height: 7px;
          background: url('../../../../assets/img/form/sanjiao.png') no-repeat center/cover;
          transform: translateY(-50%);
        }

        & .gkui-form-text {
          cursor: pointer;
        }
      }
    }
  }

  & .select-dropdown {
    box-sizing: border-box;
    position: absolute; z-index: 100; top: 48px;
    padding: 10px 0;
    width: 175px; max-height: 200px;
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
    background: #ffffff;
    border: 1px solid $grayForm; border-radius: 4px;
    box-shadow: 6px 10px 16px rgba(0, 0, 0, 0.2);

    & li {
      height: 40px;
      padding: 0 10px;
      line-height: 40px;
      font-size: 16px;
      color: $bodyBlack;
      @extend %transition;

      &.isActive {
        position: relative;
        background: $blueHoverNew;
        color: #fff;
        &::after {
          content: '';
          position: absolute;
          right: 20px; top: 50%;
          width: 12px; height: 6px;
          border-left: 2px solid #fff;
          border-bottom: 2px solid #fff;
          transform: translateY(-50%) rotate(-45deg);
        }
      }

      &:hover {
        background: $blueHoverNew;
        color: #fff;
        @extend %transition;
      }
    }
  }
}
</style>
